import React, { useEffect, useState } from "react";
import CreateUser from "../../components/CreateUser/CreateUser";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import PortalModal from "../../Portals";
import {
  ContentModalCreateUser,
  CloseModalCreateUser,
  TextModalCreateUser,
  ButtonCreateUser,
  ButtonUsersupload,
  ButtonUsersuploadCancel,
} from "./CreateUserContainer.styled";
import { useMutation, useLazyQuery } from "@apollo/client";
import imgInfo from "../../assets/imgInfo.png";
import {
  ROLE_BY_LEVEL,
  COUNTRIES_BY_CLIENT_ID,
  ALL_LOBS_COUNTRY,
  USERS_IN_ROLE2,
  LOBS_LIST_BY_COUNTRY,
  USER_DETAIL_BY_ID,
  COUNTRIES_BY_CLIENT_FOR_CREATE_USERS,
  GET_CLIENTS_ACCOUNTS,
} from "../../GraphQL/Queries";
import {
  CHANGE_STATUS_USER_BY_CLIENT_ID,
  CREATE_USER,
  CREATE_USER_IN_CLIENT,
  UPDATE_USER,
  UPDATE_USER_CLIENT,
} from "../../GraphQL/Mutations";
import { getStateLogin, getStateLoginComplete } from "../LayoutHome/stateLogin";
import { NotificationManager } from "react-notifications";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { ROLES } from "../../util/RolesConstants";

const CreateUserContainer = ({
  EditUser,
  action,
  setFormTrigger,
  bulkUploadUsers,
}) => {
  const [userComplete] = useState(getStateLoginComplete());
  const [cities, setCities] = useState([]);
  const [citiesListAccount, setCitiesListAccount] = useState([]);
  const [openModal, setOpenModal] = useState({ show: false, error: false });
  const [messageError, setMessageError] = useState("");
  const [dataBulk, setdataBulk] = useState({});
  const [showLoader, setshowLoader] = useState(false);
  const [createUser] = useMutation(CREATE_USER);
  const [updateUser] = useMutation(UPDATE_USER);
  const [createUserInClient] = useMutation(CREATE_USER_IN_CLIENT);
  const [updateUserInClient] = useMutation(UPDATE_USER_CLIENT);
  const [changeStatusUser] = useMutation(CHANGE_STATUS_USER_BY_CLIENT_ID);
  const [userInfo, setUserInfo] = useState();
  const [lobsByCountry, setLobsByCountry] = useState([]);
  const [lobsByCountryAccount, setLobsByCountryAccount] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countryListAccount, setCountryListAccount] = useState([]);
  const [superVisorList, setSuperVisorList] = useState([]);
  const [superVisorListAccount, setSuperVisorListAccount] = useState([]);
  const [getComoNoComo, setGetComoNoComo] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [showAddAccount, setShowAddAccount] = useState(false);
  const [roles, setRoles] = useState([]);
  const [formsAddAccount, setFormsAddAccount] = useState([]);
  const [formsEditAccount, setFormsEditAccount] = useState([]);
  const [runQueryRolesByLevel, { loading: loadingRolesByLevel }] = useLazyQuery(
    ROLE_BY_LEVEL,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let rolesArr = data?.rolesByUserProfile?.map((e) => ({
          ...e,
        }));
        setRoles(rolesArr);
      },
    }
  );
  const [runQueryGetCountries, { loading: loadingCountries }] = useLazyQuery(
    COUNTRIES_BY_CLIENT_FOR_CREATE_USERS,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let countriesArr = data.countryLocationList.map((e) => ({
          ...e,
        }));
        setCountryList(countriesArr);
      },
    }
  );
  const [runQueryGetCountriesAccount, { loading: loadingCountryAccount }] =
    useLazyQuery(COUNTRIES_BY_CLIENT_ID, {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let countriesArr = data.countryLocationList.map((e) => ({ ...e }));
        setCountryListAccount(countriesArr);
      },
    });

  const [runQueryLobsByCountry, { loading: loadingLobsByCountry }] =
    useLazyQuery(ALL_LOBS_COUNTRY, {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setLobsByCountry(data);
      },
    });

  const [
    runQueryLobsByCountryAccount,
    { loading: loadingLobsByCountryAccount },
  ] = useLazyQuery(LOBS_LIST_BY_COUNTRY, {
    context: { clientName: "LinkUsers" },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setLobsByCountryAccount(data);
    },
  });

  const [runQueryUserInfo, { loading: loadingUserInfo }] = useLazyQuery(
    USER_DETAIL_BY_ID,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.userDetailById?.userId) {
          let userDetail = data.userDetailById;
          setUserInfo(userDetail);
        }
      },
    }
  );

  const [runQueryUsersInRole2, { loading: loadingSupervisor }] = useLazyQuery(
    USERS_IN_ROLE2,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let usersInRole2 = data.userListAdvancedSearch.map((element) => {
          return {
            id: element?.userId,
            name:
              element?.userFirstName +
              " " +
              element?.userLastName +
              " - " +
              element?.userCcms,
            firstName: element?.userFirstName,
            lastName: element?.userLastName,
          };
        });
        setSuperVisorList(usersInRole2);
      },
    }
  );

  const [runQueryUsersInRole2Account, { loading: loadingSupervisorAccount }] =
    useLazyQuery(USERS_IN_ROLE2, {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let usersInRole2 = data.userListAdvancedSearch.map((element) => {
          return {
            id: element?.userId,
            name:
              element?.userFirstName +
              " " +
              element?.userLastName +
              " - " +
              element?.userCcms,
            firstName: element?.userFirstName,
            lastName: element?.userLastName,
          };
        });
        setSuperVisorListAccount(usersInRole2);
      },
    });

  const [runQueryGetClients, { loading: loadingClients }] = useLazyQuery(
    GET_CLIENTS_ACCOUNTS,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let dto = data.clientList.map((m) => ({ ...m }));
        setClientList(dto);
      },
    }
  );

  const getComoNoComoAccount = (id) => {
    if (id === "1") {
      return true;
    } else if (id === "2") {
      return false;
    } else {
      return null;
    }
  };

  const getCities = (id) => {
    runQueryLobsByCountry({
      variables: {
        countryId: parseInt(id),
      },
    });
    let selectedCountry = countryList.filter((e) => e.id === parseInt(id));
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          id: e.cityId,
          name: e.cityName,
        };
      });
      setCities(citiesArr);
    } else {
      setCities([]);
    }
  };

  const getCitiesAccount = (countryId, clientId) => {
    if (countryId && clientId) {
      let selectedCountry = countryListAccount.filter(
        (e) => e.id === parseInt(countryId)
      );
      if (selectedCountry?.length > 0) {
        let citiesArr = selectedCountry[0].cities.map((e) => {
          return {
            ...e,
            id: e.cityId,
            name: e.cityName,
          };
        });
        setCitiesListAccount(citiesArr);
      } else {
        setCitiesListAccount([]);
      }
    }
  };

  const getLobsAccount = (countryId, clientId) => {
    if (countryId && clientId) {
      runQueryLobsByCountryAccount({
        variables: {
          countryId: parseInt(countryId),
          clientId: parseInt(clientId),
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
    }
  };

  const getCountriesAccount = (clientId) => {
    if (clientId) {
      runQueryGetCountriesAccount({
        variables: {
          clientId: parseInt(clientId),
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
      let rolesId = [
        ROLES.SUPER_ADMIN,
        ROLES.GAM,
        ROLES.COUNTRY_ADMIN,
        ROLES.SUPERVISOR,
        ROLES.WELLNESS_PROFESSIONAL,
      ];
      runQueryUsersInRole2Account({
        variables: {
          rolesId: rolesId,
          clientId: parseInt(clientId),
        },
      }).catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
    }
  };

  const createUserNew = (data) => {
    setshowLoader(true);
    createUser({
      variables: {
        rolId: parseInt(data.Role),
        userName: data.UserName,
        firstName: data.FirstName,
        lastName: data.LastName,
        createUser: getStateLogin(),
        userEmailAddress: data.TpId,
        lobIds: data.lobs,
        active: data.active,
        cityId: parseInt(data.City),
        supervisorId:
          data.UsersSupervisor == 0
            ? undefined
            : parseInt(data.UsersSupervisor),
        isCoMoUser:
          getComoNoComo === true
            ? getComoNoComo
            : getComoNoComo === false
            ? getComoNoComo
            : null,
        userMailBox: data.Email,
      },
      context: { clientName: "LinkUsers" },
    })
      .then((value) => {
        setshowLoader(false);
        if (typeof value.data === "object") {
          if (value.data?.createUser?.userId) {
            NotificationManager.success("User created successfully", "", 5000);
            setShowAddAccount(!showAddAccount);
            return;
          } else {
            setMessageError("Error creating user");
          }
        } else {
          setMessageError("Error creating user");
        }
      })
      .catch((error) => {
        setshowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const updateUserOld = (data, userId) => {
    let userInfoTpId;
    if (userInfo) {
      userInfoTpId = userInfo.userTpId.toString();
    } else {
      userInfoTpId = data.TpId;
    }
    let payload = {
      userId: userId,
      roleId: parseInt(data.Role),
      firstName: data.FirstName,
      lastName: data.LastName,
      userEmailAddress: userInfoTpId,
      newEmailAddress: data.TpId,
      cityId: parseInt(data.City),
      userName: data.UserName,
      lobIds: data.lobs,
      active: data.active,
      userMailBox: data.Email,
      isCoMoUser:
        getComoNoComo === true
          ? getComoNoComo
          : getComoNoComo === false
          ? getComoNoComo
          : null,
      supervisorId:
        data.UsersSupervisor == 0 ? undefined : parseInt(data.UsersSupervisor),
    };
    setshowLoader(true);
    updateUser({
      variables: payload,
      context: { clientName: "LinkUsers" },
    })
      .then((value) => {
        setshowLoader(false);
        if (typeof value.data === "object") {
          if (value.data?.updateUser?.userId) {
            NotificationManager.success("User created successfully", "", 5000);
            setShowAddAccount(!showAddAccount);
            return;
          } else {
            setMessageError("Error updating user");
          }
        } else {
          setMessageError("Error updating user");
        }
      })
      .catch((error) => {
        setshowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const createNewAccount = (data) => {
    let comoNoComoFlag = getComoNoComoAccount(data["Como/NonComoAccount"]);
    setshowLoader(true);
    createUserInClient({
      variables: {
        clientId: parseInt(data.ClientAccount),
        userTpId: data.tpid,
        roleId: parseInt(data.RoleAccount),
        lobIds: data.lobsAccount,
        isActive: data.active,
        cityId: parseInt(data.CityAccount),
        supervisorId:
          data.UsersSupervisorAccount == 0
            ? undefined
            : parseInt(data.UsersSupervisorAccount),
        isCoMoUser: comoNoComoFlag,
      },
      context: { clientName: "LinkUsers" },
    })
      .then((value) => {
        setshowLoader(false);
        if (typeof value.data === "object") {
          if (value.data?.createUserInClient?.userId) {
            NotificationManager.success(
              "Congratulations, a new user account has been created successfully.",
              "User Creation Account Success!",
              5000
            );
            setFormTrigger("");
            return;
          } else {
            setMessageError("Error creating user account");
          }
        } else {
          setMessageError("Error creating user account");
        }
      })
      .catch((error) => {
        setshowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const updateAccount = (data) => {
    let comoNoComoFlag = getComoNoComoAccount(data["Como/NonComoAccount"]);
    setshowLoader(true);
    updateUserInClient({
      variables: {
        clientId: parseInt(data.ClientAccount),
        userTpId: userInfo?.userTpId,
        roleId: parseInt(data.RoleAccount),
        lobIds: data.lobsAccount,
        isActive: data.active,
        cityId: parseInt(data.CityAccount),
        supervisorId:
          data.UsersSupervisorAccount == 0
            ? undefined
            : parseInt(data.UsersSupervisorAccount),
        isCoMoUser: comoNoComoFlag,
      },
      context: { clientName: "LinkUsers" },
    })
      .then((value) => {
        setshowLoader(false);
        if (typeof value.data === "object") {
          if (value.data?.updateUserInClient?.userId) {
            NotificationManager.success(
              "Congratulations, a user account has been updated successfully.",
              "User Updated Account Success!",
              5000
            );
            return;
          } else {
            setMessageError("Error creating user account");
          }
        } else {
          setMessageError("Error creating user account");
        }
      })
      .catch((error) => {
        setshowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };
  const bulkUploadUsersMessage = (data, file) => {
    if (!file.file) {
      NotificationManager.warning("Missing file to upload", "", 5000);
      return;
    }
    setOpenModal({ show: true, error: false });
    let clientSite;
    setdataBulk({ data, file, clientSite });
  };

  const handleDeleteAccount = (item, id) => {
    let clientIdSelected = item.location.clientId;
    const newForms = formsAddAccount.filter((form) => form !== id);
    setFormsEditAccount(newForms);
    setshowLoader(true);
    changeStatusUser({
      variables: {
        userEmailAddress: userInfo?.userTpId.toString(),
        newUserStatus: `${"DELETED"}`,
        clientId: clientIdSelected,
      },
      context: { clientName: "LinkUsers" },
    })
      .then((response) => {
        setshowLoader(false);
      })
      .catch((error) => {
        setshowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleGetClients = (clientId) => {
    runQueryGetClients({
      variables: {
        clientId: clientId,
      },
    });
  };

  useEffect(() => {
    if (userComplete) {
      handleGetClients(userComplete.clientId);
    }
  }, [userComplete]);

  useEffect(() => {
    if (userInfo && Array.isArray(countryList) && countryList.length > 0) {
      getCities(userInfo?.location.countryId);
    }
  }, [userInfo, countryList]);

  useEffect(() => {
    let rolesId = [
      ROLES.SUPER_ADMIN,
      ROLES.GAM,
      ROLES.COUNTRY_ADMIN,
      ROLES.SUPERVISOR,
    ];
    runQueryUsersInRole2({
      variables: { rolesId: rolesId },
    });
    runQueryGetCountries();
    runQueryRolesByLevel();
  }, []);

  useEffect(() => {
    if (userInfo) {
      runQueryGetCountriesAccount({
        variables: {
          clientId: userInfo?.location.clientId,
        },
      });
      let rolesId = [
        ROLES.SUPER_ADMIN,
        ROLES.GAM,
        ROLES.COUNTRY_ADMIN,
        ROLES.SUPERVISOR,
        ROLES.WELLNESS_PROFESSIONAL,
      ];
      runQueryUsersInRole2Account({
        variables: { rolesId: rolesId, clientId: userInfo?.location.clientId },
      });
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      userInfo &&
      Array.isArray(countryListAccount) &&
      countryListAccount.length > 0
    ) {
      getCitiesAccount(
        userInfo?.location?.countryId,
        userInfo?.location?.clientId
      );
    }
  }, [userInfo, countryListAccount]);

  useEffect(() => {
    if (action === "edit" && EditUser?.userId) {
      runQueryUserInfo({
        variables: {
          userId: EditUser?.userId,
        },
      });
    }
  }, [EditUser, action]);

  return (
    <>
      {(userInfo || action === "upload" || action === "add") && (
        <CreateUser
          action={action}
          setFormTrigger={setFormTrigger}
          profiles={roles}
          countries={countryList}
          countryListAccount={countryListAccount}
          cities={cities}
          citiesListAccount={citiesListAccount}
          allLobsByCountry={lobsByCountry}
          allLobsByCountryAccount={lobsByCountryAccount}
          EditUser={userInfo}
          getCities={getCities}
          getCitiesAccount={getCitiesAccount}
          getCountriesAccount={getCountriesAccount}
          createUserNew={createUserNew}
          updateUserOld={updateUserOld}
          bulkUploadUsersMessage={bulkUploadUsersMessage}
          createNewAccount={createNewAccount}
          updateAccount={updateAccount}
          showAddAccount={showAddAccount}
          superVisorList={superVisorList}
          superVisorListAccount={superVisorListAccount}
          setGetComoNoComo={setGetComoNoComo}
          clientList={clientList}
          handleDeleteAccount={handleDeleteAccount}
          formsAddAccount={formsAddAccount}
          setFormsAddAccount={setFormsAddAccount}
          formsEditAccount={formsEditAccount}
          setFormsEditAccount={setFormsEditAccount}
          getComoNoComoAccount={getComoNoComoAccount}
          handleGetClients={handleGetClients}
          getLobsAccount={getLobsAccount}
        ></CreateUser>
      )}
      {openModal.show && (
        <PortalModal>
          <ContentModalCreateUser>
            <CloseModalCreateUser>
              <span onClick={() => setOpenModal({ show: false, error: false })}>
                X
              </span>
            </CloseModalCreateUser>
            <TextModalCreateUser>
              {openModal.error && (
                <>
                  <ErrorOutlineIcon />
                  <p>{messageError}</p>
                </>
              )}
              {!openModal.error && action === "add" && (
                <>
                  <img
                    src={imgInfo}
                    style={{ width: "11px", height: "24px" }}
                    alt=""
                  />
                  <p>User created successfully</p>
                </>
              )}
              {!openModal.error && action === "edit" && (
                <>
                  <img
                    src={imgInfo}
                    style={{ width: "11px", height: "24px" }}
                    alt=""
                  />
                  <p>User updated successfully</p>
                </>
              )}
              {!openModal.error && action === "upload" && (
                <>
                  <img
                    src={imgInfo}
                    style={{ width: "11px", height: "24px" }}
                    alt=""
                  />
                  <div>
                    <p>You will be notified when your upload is done.</p>
                    <br />
                    <p>Are you sure you want to perform this action?</p>
                  </div>
                </>
              )}
            </TextModalCreateUser>
            {action !== "upload" && (
              <div
                style={{
                  display: "inline-flex",
                  margin: "auto",
                  width: "100%",
                }}
              >
                <ButtonCreateUser
                  onClick={() =>
                    openModal.error
                      ? setOpenModal({ show: false, error: false })
                      : setFormTrigger("")
                  }
                >
                  Ok
                </ButtonCreateUser>
              </div>
            )}
            {action === "upload" && (
              <div
                style={{
                  display: "inline-flex",
                  margin: "auto",
                  width: "100%",
                }}
              >
                <ButtonUsersupload
                  onClick={() => {
                    bulkUploadUsers(dataBulk);
                    setOpenModal({ show: false, error: false });
                    setFormTrigger("");
                  }}
                >
                  Yes
                </ButtonUsersupload>
                <ButtonUsersuploadCancel
                  onClick={() => setOpenModal({ show: false, error: false })}
                >
                  No
                </ButtonUsersuploadCancel>
              </div>
            )}
          </ContentModalCreateUser>
        </PortalModal>
      )}
      {(showLoader ||
        loadingUserInfo ||
        loadingCountries ||
        loadingCountryAccount ||
        loadingClients ||
        loadingSupervisor ||
        loadingSupervisorAccount ||
        loadingLobsByCountry ||
        loadingRolesByLevel ||
        loadingLobsByCountryAccount) && <ModalLoader />}
    </>
  );
};

export default CreateUserContainer;
